import { ref } from 'vue'

export interface Toast {
  id: number
  tone: 'success' | 'error'
  message: string
}

const toasts = ref<Toast[]>([])
let nextId = 1

/** Short confirmations after an action ("Roles updated"), and errors that have no form to show in. */
export function useToast() {
  function show(message: string, tone: Toast['tone'] = 'success'): void {
    const id = nextId++
    toasts.value.push({ id, tone, message })
    setTimeout(() => dismiss(id), tone === 'error' ? 8000 : 4000)
  }

  function dismiss(id: number): void {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  return { toasts, show, dismiss }
}
